import { action, decorate, observable } from 'mobx';
import get from 'lodash/get';
import {
  getProduct,
  postPersonalInfo,
  orderNewWallet,
  getFilenamePHOTOConfig,
  getFilenameIDCARDConfig,
  getBank,
  postFinalizeRegistration,
  activateWallet,
} from '../services/BeliKartuService';
import firebase from 'firebase/app';
import 'firebase/auth';
import { formatPhoneNumber } from '../helper/functions';
import { getCookie } from "@helpers/cookies";

class BeliKartuStore {
  formData = {};
  isLoading = false;

  product = [];
  paymentDetail = {};
  verificationData = {};

  bank = [];

  filenameIDCARD = '';
  getFilenameIDCARDConfig = async filename => {
    const { data, error } = await getFilenameIDCARDConfig(filename);

    if (data) {
      this.filenameIDCARD = data;
      this.isLoading = false;

      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  filenamePHOTO = '';
  getFilenamePHOTOConfig = async filename => {
    const { data, error } = await getFilenamePHOTOConfig(filename);

    if (data) {
      this.filenamePHOTO = data;
      this.isLoading = false;
    } else {
      this.isLoading = false;
      return { error };
    }
  };

  getProduct = async (tag = 'NEW_CARD') => {
    this.isLoading = true;

    const { data, error } = await getProduct(tag);

    if (data) {
      this.product = data;
      this.isLoading = false;
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  getBank = async () => {
    this.isLoading = true;

    const { data, error } = await getBank();

    if (data) {
      this.bank = data;
      this.isLoading = false;
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  orderNewWallet = async packageCode => {
    this.isLoading = true;

    const { data, error } = await orderNewWallet({ packageCode });

    if (data) {
      this.paymentDetail = data;
      this.isLoading = false;
    } else {
      this.isLoading = false;
      return { error };
    }
  };

  activateWallet = async ({ walletId, packageCode }) => {
    this.isLoading = true;
    const postData = {
      packageCode: packageCode,
      bank: 'MAYBANK',
      wallet: {
        address: walletId,
      },
    };
    const { data, error } = await activateWallet(postData);

    if (data) {
      this.paymentDetail = data;
      this.isLoading = false;
      return { data };
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  postPersonalInfo = async ({ deliveryAddress, city, postalCode, ktp, fullname, agentCode = '' }) => {
    this.isLoading = true;

    const postData = {
      buyer: {
        city: city,
        deliveryAddress: deliveryAddress,
        postalCode: postalCode,
        id: { account: ktp, type: 'KTP' },
        name: fullname,
      },
      wallet: {
        currency: 'BTC',
      },
    };
    
    if(getCookie('referralId')) {
      postData.wallet.agentCode = getCookie('referralId');
    } else if (agentCode.split('+62').length > 1) {
      postData.wallet.agentCode = `${formatPhoneNumber(agentCode)}`;
    }

    const { data, error } = await postPersonalInfo(postData);

    if (data) {
      this.paymentDetail = data;
      this.isLoading = false;
    } else {
      this.isLoading = false;
      return { error };
    }
  };
  postFinalizeRegistration = async ({ bankName, bankAccount, bankOwnerName, filenamePHOTO, filenameIDCARD, email }) => {
    const postData = {
      email: email,
      bank: {
        name: bankName,
        account: bankAccount,
        userName: bankOwnerName,
      },
      photoIdCard: {
        s3Bucket: 'private.cryptoket.io',
        s3Key: filenamePHOTO,
      },
      idCard: {
        s3Bucket: 'private.cryptoket.io',
        s3Key: filenameIDCARD,
      },
    };

    const { data, error } = await postFinalizeRegistration(postData);

    if (data) {
      this.verificationData = data;
      this.isLoading = false;
    } else {
      this.isLoading = false;
      return { error };
    }
  };

  setFormData = updatedData => {
    this.formData = {
      ...this.formData,
      ...updatedData,
    };
  };

  prepareDefaultValue = () => {
    this.verificationData = {};
    this.formData = {};
    this.product = [];
    this.paymentDetail = {};

    this.bank = [];

    this.filenameIDCARD = '';
    this.filenamePHOTO = '';
  };

  sendOTP = async appVerifier => {
    const phoneNumber = get(this.formData, 'phone_number', '');
    const formattedPhoneNumber = formatPhoneNumber(phoneNumber);

    return await firebase
      .auth()
      .signInWithPhoneNumber(`${formattedPhoneNumber}`, appVerifier)
      .then(confirmationResult => {
        this.setFormData({ confirmationResult: confirmationResult });
        return { result: confirmationResult };
      })
      .catch(error => {
        return { error: error };
      });
  };

  setPaymentDetail = paymentDetail => {
    this.paymentDetail = paymentDetail;
  };
}

decorate(BeliKartuStore, {
  filename: observable,
  product: observable,
  paymentDetail: observable,
  isLoading: observable,
  formData: observable,
  filenameIDCARD: observable,
  filenamePHOTO: observable,
  bank: observable,
  verificationData: observable,

  postVerificationData: action,
  getFilenamePHOTO: action,
  getFilenameIDCARD: action,
  getFilenameConfig: action,
  getWallet: action,
  prepareDefaultValue: action,
  orderNewWallet: action,
  postPersonalInfo: action,
  setPaymentDetail: action,
});
export default new BeliKartuStore();
